import React, { FC, ReactNode } from 'react';
import { Space } from '@10d/tend-ui-grid';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { Text } from 'ui/components/Typography';

import { Title, Button, Wrapper, Content, Illustration, Schedule } from './styled';

export const Page403: FC<Props> = props => {
  const { description, title, onClickMainPage, button } = props;

  return (
    <Wrapper>
      <div>
        <Illustration />
      </div>

      <Content>
        <Title level={3}>{title || 'Недостаточно прав'}</Title>

        <Space align='start' direction='vertical' size={16}>
          {description || (
            <>
              <Text color={colors.gray900}>Чтобы получить доступ, обратитесь в поддержку</Text>
              <Text color={colors.gray900}>
                Телефон: +7-495-660-41-41 <br />
                E-mail:
                <a href='mailto:servicedesk@samoletgroup.ru'>servicedesk@samoletgroup.ru</a>
                <br />
              </Text>
              <Schedule>График работы: с&nbsp;9:00 до&nbsp;21:00 без выходных</Schedule>
            </>
          )}
        </Space>

        <div>
          {button || (
            <Button type='primary' onClick={onClickMainPage}>
              На главную
            </Button>
          )}
        </div>
      </Content>
    </Wrapper>
  );
};

type Props = {
  onClickMainPage?: () => void;
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  button?: ReactNode;
};
